export default __webpack_public_path__ + "static/media/drone.76c744d4.svg";